<template>
  <div class="page-loading" :style="{ background: background || defaultBg }">
    <div class="loading-box">
      <img src="https://frontend-resource.jihuanshe.com/market/loading.svg" alt="loading" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';
const props = defineProps({
  background: { type: String, default: '' }
});
const defaultBg = '#fff';
</script>

<style scoped>
.page-loading {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 701;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading-box {}
@keyframes loading {
  0% { transform: rotate(0deg);}
  100% { transform: rotate(360deg);}
}
.loading-box img {
  width: 26px;
  height: 27px;
  animation: loading 0.8s linear infinite;
}
</style> 